<template>
  <div class="container">

    <div class="top-panel">
      <!-- <div class="arrow-btn">
          <img src="../assets/img/arrowBack.svg" class="img-pluss-btn" alt="arrow-back" />
        </div> -->
      <div class="nav-container">
        <div>
          <button @click="createItem" class="btn-create" style="gap: 5px;">Добавить приложение<svg width="14"
              height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1.16355 7.88425H5.89505V12.6158C5.89505 13.0967 6.29063 13.5 6.7793 13.5C7.26796 13.5 7.66355 13.0967 7.66355 12.6158V7.88425H12.395C12.876 7.88425 13.2793 7.48866 13.2793 7C13.2793 6.51134 12.876 6.11575 12.395 6.11575H7.66355V1.38425C7.66355 0.903341 7.26796 0.5 6.7793 0.5C6.29063 0.5 5.89505 0.903341 5.89505 1.38425V6.11575H1.16355C0.682638 6.11575 0.279297 6.51134 0.279297 7C0.279297 7.48866 0.682638 7.88425 1.16355 7.88425Z"
                fill="white" />
            </svg></button>
        </div>
      </div>
    </div>

    <div id="accounts">
      <v-container class="secondary mt-10">
        <v-row>
          <v-col>
            <v-data-table :headers="headers" :items="filteredApplication" :search="search" :footer-props="footerProps"
              hide-default-footer :mobile-breakpoint="0">
              <template v-slot:top>


                <div class="input-container">
                  <div class="chart-name-container">
                    <p class="page-title">Приложения</p>
                  </div>
                  <div class="search-component">
                    <input type="search" class="search-component__input" v-model="search" append-icon="mdi-magnify"
                      placeholder="Поиск" single-line hide-details />
                    <svg width="17" height="17" class="search-component__icon">
                      <use href="../assets/icons/icons.svg#search-icon"></use>
                    </svg>
                  </div>
                </div>



                <!-- <v-text-field
                    class="mr-10"
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Поиск"
                    single-line
                    hide-details
                  ></v-text-field> -->
                <!-- <button id="staff-add-button" @click="createItem">
                    Создать новый ресторан +
                  </button> -->
                <v-dialog v-model="dialogCreate" max-width="537px">
                  <v-card class="modal-card">
                    <v-card-title class="modal-title">
                      {{ isEditing ? "Редактирование приложения" : "Добавление приложения" }}
                      <v-spacer></v-spacer>
                      <v-btn icon @click="closeDialog">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-text>
                      <div class="card-item">
                        <div class="card-content-header">
                          <p class="card-content-text">Приложение</p>
                        </div>
                        <div class="horizontal-line mb-4"></div>
                        <!-- <v-col cols="12" class="py-0 px-0">
                            <div class="col-content px-0 pt-3 pb-0">
                              <v-col cols="3" class="col-paddings-r-l px-0 py-0">
                                <p class="col-title">Имя</p>
                              </v-col>
                              <v-col cols="1" class="py-0 pl-1 red-dot-margin-1">
                                <span class="red-dot">*</span>
                              </v-col>
                              <v-col cols="8" class="col-paddings-r-l px-0 py-0">
                                <textarea
                                  class="col-description"
                                  v-model="fullName"
                                  ref="fullNameTextarea"
                                  :placeholder="
                                    isfullNameFocused ? '' : textareaPlaceholder
                                  "
                                  @focus="isfullNameFocused = true"
                                  @blur="isfullNameFocused = false"
                                ></textarea>
                              </v-col>
                            </div>
                          </v-col> -->
                        <div class="col-content rest-name-container mb-2">
                          <p class="col-title">Название приложения<span class="red-dot">*</span></p>
                          <input class="input-css" v-model="appName" placeholder="---">
                        </div>
                        <div class="col-content rest-name-container mb-2">
                          <p class="col-title">Package Name<span class="red-dot">*</span></p>
                          <input class="input-css" v-model="packageName" placeholder="---">
                        </div>
                        <div class="col-content">
                          <p class="col-title">Тип <span class="red-dot">*</span></p>
                          <v-autocomplete v-model="appType" placeholder="---" :items="translatedApplicationList"
                            item-text="label" item-value="value" hide-details solo id="application-selector"
                            class="input-css">
                            <template v-slot:item="{ item, isSelected }">
                              <div :class="['restaurant-item', { 'active': isSelected }]">
                                {{ getRoleTranslation(item.label) }}
                              </div>
                            </template>
                          </v-autocomplete>
                        </div>
                        <div class="col-content rest-name-container mb-2">
                          <p class="col-title">Описание</p>
                          <input class="input-css" v-model="appDescription" placeholder="---">
                        </div>
                        <!-- <v-col cols="12" class="py-0 px-0">
                            <div class="col-content px-0 pt-3 pb-0">
                              <v-col cols="3" class="col-paddings-r-l px-0 py-0">
                                <p class="col-title">Бренд</p>
                              </v-col>
                              <v-col cols="1" class="py-0 pl-1 red-dot-margin-1">
                                <span class="red-dot">*</span>
                              </v-col>
                              <v-col cols="8" class="col-paddings-r-l px-0 py-0">
                                <textarea
                                  class="col-description"
                                  v-model="brandName"
                                  ref="brandNameTextarea"
                                  :placeholder="
                                    isBrandNameFocused ? '' : textareaPlaceholder
                                  "
                                  @focus="isBrandNameFocused = true"
                                  @blur="isBrandNameFocused = false"
                                ></textarea>
                              </v-col>
                            </div>
                          </v-col> -->
                      </div>
                    </v-card-text>
                    <div class="btn-container">
                      <div class="cancel-btn" text @click="closeCreate">
                        Отменить
                      </div>

                      <div class="save-btn" text @click="handleButtonClick">
                        Сохранить
                      </div>
                    </div>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogLinks" max-width="500px">
                  <v-card class="modal-card">
                    <v-card-title lass="modal-title">
                      Ссылки на приложение
                      <v-spacer></v-spacer>
                      <v-btn icon @click="dialogLinks = false">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-text>
                      <div class="card-item">
                        <div class="col-content rest-name-container mb-2">
                          <p class="col-title">Android ссылка<span class="red-dot">*</span></p>
                          <input class="input-css" v-model="androidLink" placeholder="https://play.google.com/...">
                        </div>

                        <div class="col-content rest-name-container mb-2">
                          <p class="col-title">IOS ссылка<span class="red-dot">*</span></p>
                          <input class="input-css" v-model="iosLink" placeholder="https://apps.apple.com/...">
                        </div>
                      </div>
                    </v-card-text>
                    <div class="btn-container">
                      <div class="cancel-btn" text @click="dialogLinks = false">
                        Отменить
                      </div>

                      <div class="save-btn" text @click="saveLinks">
                        Сохранить
                      </div>
                    </div>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="431px">
                  <div>
                    <div class="modal-container">
                      <p class="modal-text">Вы точно хотите удалить данное приложение?</p>
                      <div class="btn-modal-container">
                        <div class="cancel-btn" text @click="closeDelete">
                          Отмена
                        </div>
                        <div class="del-btn" text @click="deleteItemConfirm">
                          Удалить
                        </div>
                      </div>
                    </div>

                  </div>

                </v-dialog>

                <v-snackbar v-model="snackbar" :timeout="3000" class="btn-contaiener">
                  {{ message }}
                  <template v-slot:action="{ attrs }">
                    <div class="snackbar-btn" text v-bind="attrs" @click="snackbar = false">
                      Закрыть
                    </div>
                  </template>
                </v-snackbar>
              </template>
              <template v-slot:item="{ item }">
                <tr>
                  <td @click="getApplication(item)">
                    {{ item.brandName || "Не Указано" }}
                  </td>
                  <td @click="getApplication(item)">
                    {{ item.name || " " }}
                  </td>
                  <td @click="getApplication(item)">
                    {{ getRoleTranslation(item.applicationType) }}
                  </td>
                  <td style="text-align: right">
                    <v-menu offset-y left transition="scale-transition">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon medium v-bind="attrs" v-on="on">
                          mdi-dots-vertical
                        </v-icon>
                      </template>

                      <v-list class="menu-list gray-menu">
                        <v-list-item @click="getApplication(item)">
                          <v-list-item-title>Редактировать</v-list-item-title>
                        </v-list-item>

                        <v-list-item @click="deleteItem(item)">
                          <v-list-item-title>Удалить</v-list-item-title>
                        </v-list-item>

                        <v-list-item @click="openLinksDialog(item)">
                          <v-list-item-title>Ссылки на приложение</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                </tr>
              </template>
              <template v-slot:no-data>
                <div v-if="showNoDataMessage">Не найденно подходящих записей.</div>
                <v-progress-circular v-else indeterminate color="primary"></v-progress-circular>
              </template>
              <template v-slot:footer>
                <div class="v-data-footer">
                  <div class="v-data-footer__select">
                    Кол-во приложений на странице:
                    <v-select class="custom-select" v-model="itemsPerPage" :items="footerProps.itemsPerPageOptions"
                      @change="changeItemsPerPage" hide-details></v-select>
                  </div>
                  <div class="v-data-footer__pagination">
                    {{ (currentPage - 1) * itemsPerPage + 1 }} -
                    {{ Math.min(currentPage * itemsPerPage, totalItems) }} из
                    {{ totalItems }}
                  </div>
                  <div class="v-data-footer__icons-before">
                    <button type="button" :disabled="currentPage === 1"
                      class="v-btn v-btn--icon v-btn--round v-btn--text theme--light v-size--default"
                      :class="{ 'v-btn--disabled': currentPage === 1 }" aria-label="Предыдущая страница"
                      @click="goToPreviousPage">
                      <span class="v-btn__content">
                        <i aria-hidden="true" class="v-icon notranslate mdi mdi-chevron-left theme--light"></i>
                      </span>
                    </button>
                  </div>
                  <div class="v-data-footer__icons-after">
                    <button type="button" :disabled="currentPage === totalPages"
                      class="v-btn v-btn--icon v-btn--round v-btn--text theme--light v-size--default"
                      :class="{ 'v-btn--disabled': currentPage === totalPages }" aria-label="Следующая страница"
                      @click="goToNextPage">
                      <span class="v-btn__content">
                        <i aria-hidden="true" class="v-icon notranslate mdi mdi-chevron-right theme--light"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>


<script>
import { mask } from "vue-the-mask";
import { mapGetters } from "vuex";
import { debounce } from 'lodash';
export default {
  directives: { mask },
  name: "ApplicationList",

  data: () => ({
    isHovered: false,
    isHoveredTogo: false,
    showInputMenu: false,
    selectedOption: "",
    isPlaceholderHidden: false,
    isfullNameFocused: false,
    isBrandNameFocused: false,
    selectedRoles: null,
    showNoDataMessage: false,
    appName: "",
    packageName: "",
    appType: "",
    appDescription: "",
    dialogDelete: false,
    dialogCreate: false,
    search: "",
    snackbar: false,
    message: "",
    roleTranslations: {
      Owner: "Владелец",
      Administrator: "Администратор",
    },
    newApp: {
    },
    application: {
    },
    selectedType: null,
    applicationTypes: [
      { label: 'CustomerApp', value: 1 },
      { label: 'RestaurantApp', value: 2 },
      { label: 'WebApp', value: 3 }
    ],
    appTranslation: {
      CustomerApp: "Гостевое приложение",
      RestaurantApp: "Ресторанное приложение",
      WebApp: "Веб-приложение",
    },
    headers: [
      {
        text: "Название",
        align: "start",
        value: "name",
      },
      { text: "Package Name", value: "brandName" },
      { text: "Тип", value: "applicationType" },
      { text: "Действия", align: "end", value: "actions", sortable: false },
    ],
    applications: [],
    profiles: [],
    error: null,
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
    totalPages: 0,
    isEditing: false,
    currentAcc: "",
    dialogLinks: false,
    androidLink: "",
    iosLink: "",
    androidLinkId: "",
    iosLinkId: "",
  }),

  created() {
    this.initialize();
    // this.profileInfo();
  },
  computed: {
    translatedApplicationList() {
      return this.applicationTypes.map(item => ({
        ...item,
        label: this.appTranslation[item.label] || item.label
      }));
    },
    filteredApplication() {
      // Фильтруем данные внутри таблицы в зависимости от выбранного типа
      if (this.selectedType) {
        console.log(this.selectedType);
        return this.staffs.items
          .filter
          // (item) => item.rolesTest === this.selectedType
          ();
      } else {
        return this.applications.items;
      }
    },
    footerProps() {
      return {
        itemsPerPageOptions: [5, 10, 25, 50], // Опции количества элементов на странице
        itemsPerPage: this.itemsPerPage,
        currentPage: this.currentPage,
        totalItems: this.totalItems,
      };
    },
    ...mapGetters({
      user: "user",
    }),
    textareaPlaceholder() {
      return this.isPlaceholderHidden ? "" : "---";
    },
  },

  mounted() {
    window.addEventListener("click", this.handleClickOutside);
    window.addEventListener("click", this.handleClickOutsideTogo);
  },
  beforeDestroy() {
    window.removeEventListener("click", this.handleClickOutside);
    window.removeEventListener("click", this.handleClickOutsideTogo);
  },

  methods: {
    async openLinksDialog(item) {
      this.currentAcc = item.id;
      this.dialogLinks = true;
      try {
        const { data } = await this.$http.get(`/api/Application/${this.currentAcc}`);

        const android = data.links.find(l => l.osType === "Android");
        const ios = data.links.find(l => l.osType === "IOS");

        this.androidLink = android ? android.name : "";
        this.iosLink = ios ? ios.name : "";
        this.androidLinkId = android ? android.id : null;
        this.iosLinkId = ios ? ios.id : null;

        this.initialAndroidLink = this.androidLink;
        this.initialIosLink = this.iosLink;
      } catch (err) {
        this.snackbar = true;
        this.message = "Ошибка загрузки ссылок";
        console.error("Ошибка загрузки ссылок:", err);
      }
    },
    async saveLinks() {
      try {
        let added = false;
        let updated = false;
        if (this.androidLinkId && this.androidLink !== this.initialAndroidLink) {
          // обновляем только если изменилось
          await this.$http.put(`/api/ApplicationLinks/${this.androidLinkId}`, {
            id: this.androidLinkId,
            name: this.androidLink
          });
          updated = true;
        } else if (!this.androidLinkId && this.androidLink) {
          // создаём только если новой ссылки раньше не было
          await this.$http.post(`/api/ApplicationLinks`, {
            applicationId: this.currentAcc,
            osType: "Android",
            name: this.androidLink
          });
          added = true;
        }

        // iOS
        if (this.iosLinkId && this.iosLink !== this.initialIosLink) {
          await this.$http.put(`/api/ApplicationLinks/${this.iosLinkId}`, {
            id: this.iosLinkId,
            name: this.iosLink
          });
          updated = true;
        } else if (!this.iosLinkId && this.iosLink) {
          await this.$http.post(`/api/ApplicationLinks`, {
            applicationId: this.currentAcc,
            osType: "IOS",
            name: this.iosLink
          });
          added = true;
        }
        this.dialogLinks = false;
        this.androidLink = "";
        this.iosLink = "";
        if (added && updated) {
          this.message = "Ссылки успешно добавлены и обновлены";
        } else if (added) {
          this.message = "Ссылки успешно добавлены";
        } else if (updated) {
          this.message = "Ссылки успешно обновлены";
        } else {
          this.message = "Изменений нет";
        }

        this.snackbar = true;
      } catch (err) {
        console.error(err);
        this.message = "Ошибка при сохранении ссылок";
        this.snackbar = true;
      }
    },
    getRoleTranslation(role) {
      return this.appTranslation[role] || role;
    },
    getEnglishRoleTranslation(role) {
      for (const key in this.appTranslation) {
        if (Object.prototype.hasOwnProperty.call(this.appTranslation, key)) {
          if (this.appTranslation[key] === role) {
            return key;
          }
        }
      }
      return role;
    },
    hidePlaceholder(inputName) {
      if (inputName === "fullName" && inputName === "brandName") {
        this.isfullNameFocused = true;
        this.isBrandNameFocused = true;
      }
      // } else if (inputName === "actualAdress") {
      //   this.isActualAdressFocused = true;
      // }
    },

    restorePlaceholder() {
      this.isPlaceholderHidden = false;
      // this.activeTextarea = null;
    },

    adjustTextareaHeight(refName) {
      const textarea = this.$refs[refName];
      textarea.style.height = "auto";
      textarea.style.height = textarea.scrollHeight + "px";
    },
    closeDialog() {
      this.dialogCreate = false;
      this.fullName = "";
      this.brandName = "";
      this.isEditing = false;
    },
    handleButtonClick() {
      if (this.isEditing) {
        // Выполните метод для редактирования
        this.editApplication();
      } else {
        // Выполните метод для создания нового приложения
        this.createNewAccount();
      }
    },
    initialize() {
      this.$http
        .put("/api/Application/PagedList", {
          pageNumber: this.currentPage,
          pageSize: this.itemsPerPage,
          headers: {
            'Content-Type': 'application/json',
          },
          filters: [
            {
              property: "Name",
              operator: "contains",
              value: this.search,
            }
          ],
        })
        .then((response) => {
          this.applications = response.data;
          this.totalPages = response.data.totalPages; // Общее количество страниц
          this.totalItems = response.data.totalCount;
          if (this.totalItems === 0) {
            this.showNoDataMessage = true;
          } else {
            this.showNoDataMessage = false;
          }
        })
        .catch((error) => (this.error = error));
    },
    goToNextPage() {
      if (this.currentPage < this.totalItems) {
        this.currentPage++;
        this.initialize();
      }
    },
    goToPreviousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.initialize();
      }
    },
    changeItemsPerPage() {
      this.currentPage = 1; // Сбрасываем текущую страницу при изменении количества элементов на странице
      this.initialize(); // Вызов метода для загрузки данных с новым количеством элементов на странице
    },

    deleteItem(item) {
      this.editedIndex = this.applications.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.$http
        .delete(`/api/Application/${this.editedItem.id}`)
        .then(() => {
          this.applications.items.splice(this.editedIndex, 1);
          this.initialize();
          this.closeDelete();
          this.snackbar = true;
          this.message = "Приложение успешно удалено";
        })
        .catch((error) => {
          alert(error);
          this.snackbar = true;
          this.message = "Ошибка удаления приложение";
        });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    createItem() {
      this.dialogCreate = true;
      this.appName = "";
      this.packageName = "";
      this.appType = "";
      this.appDescription = "";
      this.isEditing = false;
    },

    closeCreate() {
      this.dialogCreate = false;
      this.appName = "";
      this.packageName = "";
      this.appType = "";
      this.appDescription = "";
      this.isEditing = false;
    },

    createNewAccount() {
      this.newApp.name = this.packageName || null;
      this.newApp.brandName = this.appName || null;
      this.newApp.description = this.appDescription || null;
      this.newApp.applicationType = this.appType || null;
      if (!this.appName || this.appName.trim() === '') {
        this.snackbar = true;
        this.message = "Название приложения обязательно для заполнения";
        return;
      }
      if (!this.packageName || this.packageName.trim() === '') {
        this.snackbar = true;
        this.message = "Package Name обязателен для заполнения";
        return;
      }
      if (!this.appType || this.appType === null) {
        this.snackbar = true;
        this.message = "Тип обязателен для заполнения";
        return;
      }

      this.$http
        .post("/api/Application", this.newApp)
        .then(() => {
          this.initialize();
          this.dialogCreate = false;
          // this.newAcc = {
          //   name: "",
          //   bin: "",
          //   bic: "",
          //   legalAddress: ""
          // };
          this.snackbar = true;
          this.message = "Приложение успешно добавлено"
        })
        .catch((error) => {
          this.error = error;
          this.snackbar = true;
          this.message = "Ошибка добавления Приложениe"
        });
    },
    getApplication(item) {
      this.createItem();
      this.isEditing = true;
      this.editedIndex = this.applications.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.currentAcc = item.id;
      this.$http
        .get(
          `/api/Application/${item.id}`
        )
        .then((response) => {
          this.application = response.data;
          this.appName = this.application.brandName || null;
          this.packageName = this.application.name || null;
          this.appDescription = this.application.description || null;
          const foundType = this.applicationTypes.find(item => item.label === this.application.applicationType);
          this.appType = foundType ? foundType.value : null;
        })
        .catch((error) => {
          alert(error);
        });
    },
    editApplication() {
      this.newAcc = {}
      this.application.brandName = this.appName || null;
      this.application.name = this.packageName || null;
      this.application.description = this.appDescription || null;
      this.application.applicationType = this.appType;
      if (!this.appName || this.appName.trim() === '') {
        this.snackbar = true;
        this.message = "Название приложения обязательно для заполнения";
        return;
      }
      if (!this.packageName || this.packageName.trim() === '') {
        this.snackbar = true;
        this.message = "Package Name обязателен для заполнения";
        return;
      }
      if (!this.appType || this.appType === null) {
        this.snackbar = true;
        this.message = "Тип обязателен для заполнения";
        return;
      }
      this.$http
        .put(`/api/Application/${this.currentAcc}`, this.application, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          this.initialize();
          this.dialogCreate = false;
          this.employee = response.data;
          // this.newEmp = {
          // name: "",
          // brandName: "",
          // };
          this.snackbar = true;
          this.message = "Приложение успешно измененно";
        })
        .catch((error) => {
          alert(error);
          this.snackbar = true;
          this.message = "Ошибка редактирования приложения";
        });
    },
    editItem(item) {
      this.$router.push({ path: `/admin/accounts/${item.id}` });
    },
    toggleInputMenu() {
      this.isHovered = false;
      this.showInputMenu = !this.showInputMenu;
    },

    selectOption(option) {
      this.selectedOption = option;
      this.toggleInputMenu(); // Вызовите метод для скрытия меню (если это требуется)
    },

    handleClickOutside(event) {
      const inputButton = this.$refs.inputButton;
      const inputMenu = this.$refs.inputMenu;

      if (
        inputButton &&
        inputMenu &&
        !inputButton.contains(event.target) &&
        !inputMenu.contains(event.target)
      ) {
        this.showInputMenu = false;
      }
    },

    addBorderClass() {
      this.isHovered = true;
    },
    removeBorderClass() {
      this.isHovered = false;
    },
  },
  watch: {
    fullName() {
      this.$nextTick(() => {
        this.adjustTextareaHeight("fullNameTextarea");
      });
    },
    search: debounce(function () {
      // Выполняем запрос с задержкой после изменения переменной поиска
      this.initialize();
    }, 500),
    branName() {
      this.$nextTick(() => {
        this.adjustTextareaHeight("brandNameTextarea");
      });
    },
  },
};
</script>

<style scoped>
.btn-modal-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 36.7px;
}

.modal-text {
  font-family: Inter;
  font-weight: 700;
  font-size: 24px;
  text-align: center;
  color: #323c4d;
  margin-bottom: 0px;
  line-height: normal;
}

.modal-container {
  padding: 20px 20px 37px 20px;
}

#accounts>.container {
  border-radius: 8px;
}

.chart-name-container {
  width: fit-content;
}

.input-container {
  display: flex;
  align-items: center;
  gap: 150px;
  margin-bottom: 10px;
  justify-content: space-between;
  padding: 0 9px 0;
}

.card-content-text {
  font-family: Inter;
  font-size: 20px;
  font-weight: 700;
  line-height: 24.2px;
  text-align: left;
  color: #323C4D;
  margin-bottom: 8px;
}

.card-item {
  background: #fff;
  /* max-width: 247px; */
  /* width: px; */
  border-radius: 5px;
  /* height: 620px; */
  display: flex;
  flex-direction: column;
  padding: 18px 18px 23px 18px;
}

.modal-card {
  background-color: #F8F8F8 !important;
}

.input-css {
  border-radius: 5px;
  padding: 10px 10px 10px 10px;
  /* height: 42px; */
  border: 1px solid transparent;
  outline: none;
  transition: border 0.3s ease;
  font-family: Inter;
  font-weight: 600;
  font-size: 15px;
  color: #323c4d;
}

.input-css-textarea:hover,
.input-css-textarea:focus {
  border: 1px solid #d4d4e1;
  /* Цвет бордера при наведении */
}

.input-css:hover,
.input-css:focus {
  border: 1px solid #d4d4e1;
  /* Цвет бордера при наведении */
}

.btn-create {
  /* width: 121px; */
  height: 36px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px 18px;
  border-radius: 5px;
  background: rgb(50, 60, 77);
  color: white;

}

/* Custom styles for the "Закрыть" button */
.custom-snackbar .v-btn--text.v-btn--success {
  color: #fff;
  /* White text color */
}

.custom-snackbar .v-btn--text.v-btn--success:hover {
  background-color: #357a38;
  /* Darker green background on hover */
}

.role-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.border-hover {
  border-radius: 8px;
  border: 1px solid var(--03, #c1c1c1) !important;
  /* Другие стили по вашему усмотрению */
}

.v-col.cols-7 .border-hover {
  border-radius: 8px;
  border: 1px solid var(--03, #c1c1c1) !important;
  background: var(--white, #fff);
}

.profile-menu-item:hover {
  /* Здесь вы можете задать стили для hover-эффекта */
  background-color: #f0f0f0;
  /* Пример: изменение цвета фона при наведении */
  color: #333;
  /* Пример: изменение цвета текста при наведении */
  cursor: pointer;
  /* Пример: изменение курсора при наведении */
  /* Другие стили по вашему усмотрению */
}

.border-input {
  border-radius: 8px;
  border: 1px solid var(--03, #c1c1c1) !important;
  background: var(--white, #fff);
  padding: 6px;
}

.border-white {
  border-radius: 8px;
  border: 1px solid var(--02, white);
  background: var(--white, #fff);
  padding: 6px;
  cursor: pointer;
  width: 100%;
}

.divider-modal {
  background: #e0e0e0;
  height: 1px;
  width: 100%;
  /* Расширяем на всю ширину родительского контейнера */
}

.profile-menu-item {
  color: #000;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 0px;
  padding-left: 30px;
  padding-top: 11px;
  padding-bottom: 11px;
  width: 100%;
}

.input-menu {
  position: absolute;
  bottom: 32%;
  left: 30.7%;
  width: 347px;
  height: auto;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 0px 30px 0px rgba(200, 200, 200, 0.52);
  transition: bottom 0.3s;
  padding: 0px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  z-index: 100;
  /* right: -15px; */
}

.select-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 35px;
  /* margin-left: 15px; */
}

.option-btn {
  margin-bottom: 0px;
  color: var(--Gray-1, #333);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  /* 146.667% */
  margin-left: 5px;
}

::v-deep .v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none;
}

.btn-container {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 46px;
  align-items: center;
  margin-right: 20px;
}

.red-dot-margin-2 {
  margin-left: -17px;
}

.red-dot-margin-1 {
  text-align: center;
  margin-left: -17px;
}

.btn-contaiener {
  display: flex;
  justify-content: space-evenly;
}

.cancel-btn {
  color: #eb5757;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border-radius: 8px;
  display: inline-flex;
  padding: 13px 29px;
  cursor: pointer;

}

.delete-btn {
  color: var(--Red, #eb5757);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
}

.snackbar-btn {
  color: var(--Red, #eb5757);
  font-family: Inter;
  font-size: 0.875rem;
  font-weight: 400;
  letter-spacing: 0.0178571429em;
  line-height: 1.25rem;
  margin-right: auto;
  padding: 14px 16px;
  text-align: initial;
  cursor: pointer;

}

.save-btn {
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border-radius: 8px;
  background: #323C4D;
  display: inline-flex;
  padding: 13px 29px;
  justify-content: center;
  align-items: center;
  gap: 32.5px;
  cursor: pointer;
}

.del-btn {
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border-radius: 8px;
  background: #e41313;
  display: inline-flex;
  padding: 13px 29px;
  justify-content: center;
  align-items: center;
  cursor: pointer;

}

.text-limit {
  width: 30ch;
  /* Отображение примерно 10 символов */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow: hidden;
  color: var(--Gray-1, #333);
  text-overflow: ellipsis;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  /* 146.667% */
  margin-bottom: 0px;
}

.horizontal-line {
  /* Ширина div'а будет равна 100% от родительского контейнера */
  height: 1px;
  /* Толщина линии */
  background: #D4D4E1;
  /* Цвет линии (в данном случае черный) */
}

.custom-select {
  position: relative;
  width: 350px;
  cursor: pointer;
  /* margin-left: 9px; */
  color: var(--gray-1, #333);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  /* 146.667% */
}

.select-arrow {
  position: absolute;
  top: 40%;
  right: 30px;
  /* transform: translateY(-50%); */
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #333;
  /* Цвет стрелочки */
}

.col-description,
:focus {
  outline: none;
  /* Убираем внешний контур (outline) при фокусе */
  border: none;
  /* Убираем границу (border) при фокусе */
  box-shadow: none;
  /* Убираем тень (box-shadow) при фокусе */
}

.red-dot {
  color: #e41313;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.col-title {
  color: var(--gray-1, #333);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  word-wrap: break-word;
  margin-bottom: 10px;
}

.col-paddings-r-l {
  padding-right: 0px;
  padding-left: 0px;
}

.col-content {
  display: flex;
  flex-direction: column;
}

.role-margin {
  margin-right: 37px;
}

.role-margin-1 {
  margin-right: 30px;
}

.col-content-2 {
  display: flex;
  align-items: center;
  width: fit-content;
}

.col-description {
  color: var(--gray-1, #333);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  /* 146.667% */
  margin-bottom: 0px;
  word-wrap: break-word;
  resize: none;
  height: 30px;
  /* min-height: 20px; */
  width: 100%;
  /* margin-left: 18px; */
}

::v-deep .v-dialog {
  /* border-radius: 20px; */
  background: #F8F8F8;
  margin: 24px;
  overflow-y: auto;
  pointer-events: auto;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  width: 100%;
  z-index: inherit;
  box-shadow: none;
}

.modal-title {
  color: var(--gray-1, #333);
  font-family: Inter !important;
  font-size: 24px !important;
  font-style: normal;
  font-weight: 600 !important;
  line-height: normal;
}

.page-title {
  font-family: Inter;
  font-weight: 700;
  font-size: 24px;
  color: #323c4d;
  margin-bottom: 0px;
}

.vertical-line {
  width: 1px;
  height: 42px;
  background: #e0e0e0;
  margin-left: 31px;
}

.vertical-line-1 {
  width: 1px;
  height: 50px;
  background: #e0e0e0;
}

.add-btn .add-text {
  color: var(--01, #333);
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 0px;
  margin-left: 12px;
  transition: color 0.3s ease;
}

.add-btn:hover .add-text {
  /* Цвет текста при наведении */
  color: black;
  /* Замените "red" на желаемый цвет текста */
  font-weight: 500;
  font-size: 17px;
}

.add-btn {
  display: flex;
  align-items: center;
  padding: 12px 0px;
  margin-left: 37px;
  cursor: pointer;
}

.top-panel {
  height: 31px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 14px;
}

.search-container {
  padding-left: 40px;
  padding-right: 30px;
  padding-top: 17px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.img-pluss-btn {
  margin-left: 10px;
}

.arrow-btn {
  /* border-right: 1px solid var(--04, #eaeaea); */
  width: 56px;
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.search-notfound {
  /* display: flex; */
  margin: 0 auto;
  font-family: "Inter";
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
}

.search-component {
  max-width: 606px;
  width: 100%;
  height: 45px;
  display: flex;
  position: relative;
  flex-direction: row;
  justify-content: flex-start;
}

.search-component__input {
  border: 1px solid rgb(224, 224, 224);
  border-radius: 5px;
  width: 100%;
  outline: unset;
  padding: 0 40px 0 15px;
  display: flex;
  align-items: center;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
}


.search-component__icon {
  position: absolute;
  top: 14.5px;
  right: 15px;
}

#staff-add-button {
  border-radius: 8px;
  background-color: #333;
  color: var(--white, #fff);
  gap: 12px;
  padding: 10px 56px;
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  height: 45px;
}

::v-deep tbody tr:nth-child(2n) {
  background: rgba(242, 242, 246, 0.5);
}

::v-deep .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  color: var(--gray-1, #333) !important;
  font-family: Inter;
  font-size: 16px !important;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

::v-deep .v-data-table__wrapper>table>thead>tr>th {
  color: #606c80 !important;
  font-family: Inter;
  font-size: 16px !important;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-wrap: nowrap;

}

::v-deep .theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr:last-child>th {
  border-bottom: 2px solid #606c80;
}

.nav-container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

::v-deep .v-autocomplete__content.v-menu__content {
  color: #000;
  background-color: #000;
  background: #000;
}

::v-deep .v-autocomplete__content .v-list-item__title {
  color: black;
  /* Цвет текста */
}

::v-deep .v-autocomplete__content.v-menu__content {
  color: #000;
  background-color: #000;
  background: #000;
}

::v-deep .v-autocomplete.v-input--outlined .v-input__control {
  border: none !important;
}

::v-deep .v-autocomplete__content.v-menu__content .v-select-list {
  border-radius: 0 0 4px 4px;
  background: green;
}

::v-deep .v-autocomplete__content input {
  border: 1px solid rgb(224, 224, 224);
  border-radius: 5px;
  width: 100%;
  outline: unset;
  padding: 0 40px 0 15px;
  display: flex;
  align-items: center;
}

::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  box-shadow: none !important;
  /* border: 1px solid rgb(224, 224, 224); */
}

::v-deep .v-text-field--outlined fieldset {
  border: none !important;
}

.restaurant-item {
  color: #000;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.restaurant-item :first-child {
  /* padding-left: 10px; */
  color: #000;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

::v-deep .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: #000 !important;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 0px;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 0px;
  padding-bottom: 0px;
  width: 100%;
  border-bottom: 0.5px solid rgb(212, 212, 225);
}

.gray-menu {
  background: #f5f5f5;
  /* светло-серый */
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 4px 0;
}

.v-list-item {
  transition: background 0.2s;
}

.v-list-item:hover {
  background: rgba(0, 0, 0, 0.05);
  /* серый hover */
}

@media (min-width: 1264px) {
  .container {
    max-width: 100% !important;
  }
}

@media (min-width: 960px) {
  .container {
    max-width: 100% !important;
  }
}

@media (max-width: 1069px) {
  .v-card__title {
    flex-wrap: nowrap;
  }

  .modal-title {
    color: #323c4d;
    font-family: Inter !important;
    font-size: 24px !important;
    font-style: normal;
    font-weight: 600 !important;
    line-height: normal;
    word-break: auto-phrase;
  }

  .input-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    margin-bottom: 10px;
  }

  .v-data-footer__select {
    display: flex;
    align-items: center;
    flex: 1 1 auto;
    justify-content: flex-start;
    white-space: normal;
    width: 200px;
  }

  .search-component {
    max-width: 306px;
    width: 100%;
    height: 45px;
    display: flex;
    position: relative;
    flex-direction: row;
    justify-content: flex-start;
  }

  .top-panel {
    height: 31px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 24px;
  }
}
</style>